import React, { useContext } from "react";
import DruidWebchatContext, { DruidWebchatContextType } from "../WebChatContext";
import { DruidHeader } from "./header/DruidHeader";
import { FaExclamationTriangle } from "react-icons/fa";
import { useDeterminedDirection } from "../selectors/useDeterminedDirection";

export function ErrorFallback({error, resetErrorBoundary}) {
    const [, druidWebChatDispatch,, ] = useContext<DruidWebchatContextType>(DruidWebchatContext);
    const determinedDir = useDeterminedDirection();
    return (
      <React.Fragment>
        <DruidHeader>
        </DruidHeader>
          <div className={`connect-spinner`} dir={determinedDir}>
            <div className="content">
              
              {<p><FaExclamationTriangle size={18}/>  Something went wrong. </p>}
              {<p>You could <a href="#!" onClick={(e) => {e.preventDefault(); druidWebChatDispatch({ type: 'RESET', withAutoExpand: true })}}>Try Again</a> or <a href="#!" onClick={(e) => { e.preventDefault(); druidWebChatDispatch({ type: 'RESET', includingCookies: true, withAutoExpand: true })}}>RESET conversation</a></p>}
            </div>
          </div>
      </React.Fragment>
    )
  }